import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { ScheduleQueryInvalidators } from '@frontend/api-schedule';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useTranslation } from '@frontend/i18n';
import { useScheduleRequestNotification } from '@frontend/notifications';
import { openSchedulePulseRequest } from '@frontend/schedule';
import { GetWeavePopNotificationByType } from '@frontend/types';
import { useWebsocketEventSubscription } from '@frontend/websocket';

const openAndExpandeScheduleRequest = (notification: GetWeavePopNotificationByType<'schedule-request-new'>) => {
  const locationId = notification?.payload?.locationId;
  const scheduleRequestId = notification.payload?.id;

  if (locationId && scheduleRequestId) {
    openSchedulePulseRequest(locationId, scheduleRequestId);
  }
};

export const useWebsocketScheduleRequestEventSubscription = () => {
  const { create } = useScheduleRequestNotification(openAndExpandeScheduleRequest);
  const { t } = useTranslation('notifications');
  const { invalidateScheduleRequestListAndCount } =
    ScheduleQueryInvalidators.useScheduleRequestListAndCountInvalidation();
  const { invalidateListScheduleActivity } = SchedulerV3.Helpers.useSchedulerV3InvalidateQueries();

  return useWebsocketEventSubscription(NotificationType.SCHEDULE_REQUEST, (payload) => {
    const locationId = 'locationID' in payload ? (payload?.locationID as string) : undefined;
    const notification = {
      id: payload.id,
      timestamp: Date.now(),
      type: 'schedule-request-new',
      payload: {
        locationId,
        notificationType: 'ScheduleRequest',
        appointmentType: payload.params.appointmentType || '',
        dateTime: payload.params.dateTime || '',
        id: payload.params.id || '',
        durationMinutes: payload.params.durationMinutes || 0,
        note: payload.params.note || '',
        schedulee: {
          firstName: payload.params.schedulee?.firstName || '',
          lastName: payload.params.schedulee?.lastName || '',
          phoneNumber: payload.params.schedulee?.phoneNumber || '',
          email: payload.params.schedulee?.email || '',
          WeavePersonID: payload.params.schedulee?.WeavePersonID || '',
        },
      },
      state: {
        paused: false,
        status: 'unread',
      },
    } satisfies GetWeavePopNotificationByType<'schedule-request-new'>;

    create(notification, {
      os: {
        title: t('New Schedule Request'),
        body: `${payload.params.schedulee?.firstName || ''} ${payload.params.schedulee?.lastName || ''}`.trim(),
      },
    });

    invalidateScheduleRequestListAndCount();
    invalidateListScheduleActivity({ locationId });
  });
};
